import * as request from 'request';
//import * as nodemailer from 'nodemailer';
import 'dotenv/config';

export async function sendTextLocalSMS(mobileNo, MSG_TEMPLATE) {
    let options = {
        apikey: process.env.TEXT_LOCAL_API_KEY,
        message: MSG_TEMPLATE,
        sender: process.env.TEXT_LOCAL_SENDER,
        numbers: mobileNo
    };
    return new Promise((resolve, reject) => {
        request.post({ url: process.env.TEXT_LOCAL_HOST, form: options }, (error: any, response: any, body: any) => {
			if (error) {
				return reject(error);
			}
			resolve({ response, body });
		});
    });
}

